import { render, staticRenderFns } from "./picker-seckill.vue?vue&type=template&id=1dc1f54c"
import script from "./picker-seckill.vue?vue&type=script&lang=js"
export * from "./picker-seckill.vue?vue&type=script&lang=js"
import style0 from "./picker-seckill.vue?vue&type=style&index=0&id=1dc1f54c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports